/// <reference path="index.d.ts" />
import * as React from 'react'
import { Dialog } from '@alifd/next';
import doLog from '../../common/log';
import { store,EVENT } from '../../store'
import { resetUrl } from '../../common/reset-image';
import SliderTab from './slider-tab';

const { useState,useEffect,useContext } = React;

export default function MainDialog ( props: PropsInterface ) {
    const { productId,mediaItems,i18n,sliderIndex,setSliderIndex } = props;
    const { state } = useContext( store )

    const [imageList,setImageList] = useState( {} );

    const fetchImage = async () => {
        const result = await fetch( `/event/app/detailBoothImage/median.htm?detailId=${productId}&language=en` )
            .then( rst => rst.json() );
        const dataSource = {} as any;
        mediaItems.concat( result?.data ).map( ( item: ImageInterface ) => {
            dataSource[item.bizType] = dataSource[item.bizType] || [];
            dataSource[item.bizType].push( {
                type: item.type,
                url: resetUrl( item?.cover
                    || item?.videoCoverUrl
                    || item?.customHome?.cover
                    || item.certImageUrlList && item?.certImageUrlList[0]?.big
                    || item.imageUrl?.big
                    || '//s.alicdn.com/@img/imgextra/i1/O1CN01JN6Qwv25utiKXfKGz_!!6000000007587-0-tps-255-198.jpg'
                ),
                item
            } );
        } );
        setImageList( dataSource );

    };

    useEffect( () => {
        fetchImage();
    },[] );

    useEffect( () => {
        // 商品证书点击
        if ( state.type === EVENT.certification ) {
          doLog(
            '/sc.details.commonLogs',
            'action=openCertificationImageDialog',
          );
          // 弹出
          setSliderIndex( {
              tabIndex: Object.keys( imageList ).length - 1 || 0,
              visibleId: state.payload
          } );
        }
    },[state] )

    const { visibleId,tabIndex } = sliderIndex;


    return (
        <Dialog
            visible={visibleId > -1}
            footerActions={[]}
            onClose={() => setSliderIndex( {
                tabIndex: 0,
                visibleId: -1
            } )}
        >
            <SliderTab data={imageList} tabIndex={tabIndex} setSliderIndex={setSliderIndex} visibleId={visibleId} i18n={i18n} />
        </Dialog>
    )
}
